import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-box" }

import {ref, onMounted} from 'vue';
	import {useRouter} from 'vue-router';
	import {FetchData} from "../utils/FetchData";
	import FetchOptions from '../interfaces/FetchOptions';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'InvitePage',
  setup(__props) {

	const error = ref('');
	const showInput = ref(false);
	const input = ref('');
	const router = useRouter();

	onMounted(() => {
		lookForCode();
	});

	function lookForCode() {
		const code = router.currentRoute.value.params.catchAll;
		if(code == undefined) {
			error.value = 'Code invoeren';
			showInput.value = true;
			return;
		}

		if(code.length == 0) {
			error.value = 'Code invoeren';
			showInput.value = true;
			return;
		}

		checkCode(code as string);
	}

	function enterCode() {
		checkCode(input.value);
	}

	async function checkCode(code: string) {
		if(code.length == 0)
			return;

		const options: FetchOptions = {
			method: 'POST',
			headers: {
				"Content-Type": 'application/json'
			},
			body: JSON.stringify({code: code})
		}

		const data = await FetchData('codes', options, true);
		if(!data.isError) {
			router.replace({path: '/', query: {season: data.data.id}})
			return;
		}

		error.value = data.msg;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString(error.value), 1),
    (showInput.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Code",
              maxlength: "8",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event))
            }, null, 512), [
              [_vModelText, input.value]
            ])
          ]),
          _createElementVNode("button", {
            class: "content-box",
            onClick: enterCode
          }, "Invoeren")
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})